import { ROUTE_PATH, OperationType, USER_TYPE } from "common/constants/sm-constants";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class AdminTravelReimbursementGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Reimbursement',
            ROUTE_PATH.travelReimbursement,
            ROUTE_PATH.addTravelReimbursement,
            false,
            false,
            8,
            false,
            false,
            ['topic','type'],
            true,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            { evalKey: '', evalParam: ['1'], decisiveParam: true },
            false,
            false,
            false,
            null,
            { evalKey: '', evalParam: ['1'], decisiveParam: true },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            []);
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const topic = new Headers('Topic', 'topic', false, true, 'text');
        const type = new Headers('Type', 'type', false, true, 'text');
        const invited_student = new Headers('Total Invited', 'invited_student', false, true,
            'text',
            '0',
            {
                isColumnNavigation: true,
                navigationUrl: ROUTE_PATH.adminTravelDetail,
                navigateOperationType: OperationType.VIEW,
                navigateTransferData: new GridParams(),
                navigatePageName: '0',
            },);
        const travelDocUploaded_studentCount = new Headers('Total Uploaded', 'travelDocUploaded_studentCount', false, true, 'text', '0',
            {
                isColumnNavigation: true,
                navigationUrl: ROUTE_PATH.adminTravelDetail,
                navigateOperationType: OperationType.VIEW,
                navigateTransferData: new GridParams(),
                navigatePageName: '3',
            },);
        const travelDocnotUploaded_studentCount = new Headers('Total Not Uploaded', 'travelDocnotUploaded_studentCount', false, true, 'text', '0',
            {
                isColumnNavigation: true,
                navigationUrl: ROUTE_PATH.adminTravelDetail,
                navigateOperationType: OperationType.VIEW,
                navigateTransferData: new GridParams(),
                navigatePageName: '4',
            },);
        const attended_student = new Headers('Attended & Uploaded', 'attendedtravelDocUploaded_studentCount', false, true, 'text', '0',
            {
                isColumnNavigation: true,
                navigationUrl: ROUTE_PATH.adminTravelDetail,
                navigateOperationType: OperationType.VIEW,
                navigateTransferData: new GridParams(),
                navigatePageName: '5',
            },);
        const notattended_student = new Headers('Attended & Not-uploaded', 'attendedNotUploadDocCount', false, true, 'text', '0',
            {
                isColumnNavigation: true,
                navigationUrl: ROUTE_PATH.adminTravelDetail,
                navigateOperationType: OperationType.VIEW,
                navigateTransferData: new GridParams(),
                navigatePageName: '6',
            },);
        // const attended_student = new Headers('Attended & Uploaded', 'attendedtravelDocUploaded_studentCount', false, true, 'text');
        // const notattended_student = new Headers('Attended & Not-uploaded', 'attendedtravelDocnotUploaded_studentCount', false, true, 'text');


        headers.push(topic);
        headers.push(type);
        headers.push(invited_student);
        headers.push(travelDocUploaded_studentCount);
        headers.push(travelDocnotUploaded_studentCount);
        headers.push(attended_student);
        headers.push(notattended_student);

        return headers;
    }

    // getApprovalStatus() {
    //     const userRole = JSON.parse(localStorage.getItem('profile')).role;
    //     return userRole === USER_TYPE.admin;
    // }
}